<template>
	<div>
		<Header></Header>
		<Search :seachcon='keyword' :catid='id'></Search>
		<Nav></Nav>
		<div class="content">
			<div class="w">
				<!-- 热卖推荐 -->
				<div class="hot" v-if="ttshop_hotshop.length">
					<img class="img-default hot-img" src="../../assets/images/hot.svg" alt />
					<div class="hot-list">
						<div class="item" v-for="(item,index) in ttshop_hotshop" :key="index">
							<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank">
								<img class="img-default item-img" :src="item.pic_url" alt :onerror="errorImg" />
								<div class="item-r">
									<div class="item-name">{{item.name}}</div>
									<!-- 价格面议 -->
									<template v-if="item.preActivityGoods">
										<div class="item-pic">￥{{item.preActivityGoods.pre_price}}</div>
									</template>
									<template v-else>
										<div class="item-pic" v-if="item.is_negotiable == 0">¥{{item.price}}</div>
										<div class="item-pic" v-else>{{item.price}}</div>
									</template>
									
									<div class="item-btn">立即购买</div>
								</div>
							</router-link>
						</div>
					</div>
				</div>
				<!-- 面包屑 -->
				<div class="nav d-flex align-items-center">
					<div class="nav-item d-flex align-items-center">
						<router-link to="/">首页</router-link>
					</div>
					<img class="img-default nav-img" src="../../assets/images/rigth.png" alt v-if='ttshop_catlist.length' />
					<!-- <dl class="nav-items" v-if='ttshop_catlist.length'>
						<dt class="d-flex align-items-center">
							<div v-for="(item,index) in ttshop_catlist" :key="index" v-if="item.id == id">{{item.name}}</div>
							<img class="img-default nav-xia" src="../../assets/images/top_xia.svg" alt />
						</dt>
						<dd class="d-flex flex-wrap">
							<div v-for="(item,index) in ttshop_catlist" :key="index" @click="sort(item.id)">{{item.name}}</div>
						</dd>
					</dl> -->
					<div class="d-flex align-items-center" v-if="ttshop_catlist.length">
						<dl class="nav-items d-flex align-items-center" v-for="(item,index) in ttshop_catlist" :key="index">
							<dt class="d-flex align-items-center">
								<div v-for="(i,b) in item" :key="b" v-if="i.is_sel == 1">{{i.name}}</div>
								<img class="img-default nav-xia" src="../../assets/images/top_xia.svg" alt />
							</dt>
							<dd class="d-flex flex-wrap">
								<div v-for="(i,b) in item" :key="b" @click="sort(i.id)">{{i.name}}</div>
							</dd>
							<img class="img-default nav-img" src="../../assets/images/rigth.png" alt v-if="index!=ttshop_catlist.length-1" />
						</dl>
					</div>
					<img class="img-default nav-img" src="../../assets/images/rigth.png" alt v-if="brand_id" />
					<div class="nav-option d-flex align-items-center" v-for="(item,index) in ttshop_brand" :key="index" v-if="item.id == brand_id">
						品牌：
						<span>{{item.name}}</span>
						<img class="img-default nav-del" src="../../assets/images/nav_del.png" alt @click="closeid()" />
					</div>
				</div>
				<!-- 品牌 -->
				<div class="brand d-flex" v-if="ttshop_brand.length">
					<div class="brand-name">品牌</div>
					<div class="brand-c">
						<ul class="brand-index d-flex" v-if="brandIndex" style="display: none;">
							<li class="brand-active">所有品牌</li>
							<li>a</li>
							<li class="brand-active">b</li>
							<li>c</li>
							<li>d</li>
						</ul>
						<ul class="brand-box d-flex flex-wrap" :class="{brand_active:brandIndex}">
							<li class="brand-item" v-for="(item,index) in ttshop_brand" :key="index" @click="selectBrand(item.id)">
								<div>
									<img class="img-default" :src="item.pic_url" alt="">
								</div>
								<div class="brand-po d-flex align-items-center justify-content-center">{{item.name}}</div>
							</li>
						</ul>
						<div class="brand-btn d-flex justify-content-center" v-if="!more">
							<span class="confirm d-flex align-items-center justify-content-center" @click="brandConfirm">确定</span>
							<span class="cancel d-flex align-items-center justify-content-center" @click="brandCancel">取消</span>
						</div>
					</div>
					<div class="brand-btn d-flex" v-if="more && ttshop_brand.length>12">
						<div class="brand-btn-item d-flex align-items-center" @click="unfoldBrand(1)">
							{{brandIndex?'收起':'更多'}}
							<img class="img-default btn-img" src="../../assets/images/bottom_14.png" alt />
						</div>
						<!-- <div class="brand-btn-item d-flex align-items-center" @click="moreSelect">
							多选
							<img class="img-default btn-img" src="../../assets/images/jia.png" alt />
						</div> -->
					</div>
				</div>
				<!-- 尺码 -->
				<!-- <div class="size d-flex">
					<div class="size-name">尺码</div>
					<div class="size-c">
						<ul class="d-flex flex-wrap">
							<li class="size-item" v-for="item in 16" :key="item">{{item}}</li>
						</ul>
					</div>
					<div class="size-btn d-flex">
						<div class="size-btn-item d-flex align-items-center">
							更多
							<img class="img-default btn-img" src="../../assets/images/bottom_14.png" alt />
						</div>
						<div class="size-btn-item d-flex align-items-center">
							多选
							<img class="img-default btn-img" src="../../assets/images/jia.png" alt />
						</div>
					</div>
				</div> -->
				<!-- 颜色 -->
				<!-- <div class="color d-flex">
					<div class="color-name">颜色</div>
					<div class="color-c">
						<ul class="d-flex flex-wrap">
							<li class="color-item" v-for="item in 16" :key="item"></li>
						</ul>
					</div>
					<div class="color-btn d-flex">
						<div class="color-btn-item d-flex align-items-center">
							更多
							<img class="img-default btn-img" src="../../assets/images/bottom_14.png" alt />
						</div>
						<div class="color-btn-item d-flex align-items-center">
							多选
							<img class="img-default btn-img" src="../../assets/images/jia.png" alt />
						</div>
					</div>
				</div> -->
				<!-- 风格 -->
				<!-- <div class="style d-flex">
					<div class="style-name">风格</div>
					<div class="style-c">
						<ul class="d-flex flex-wrap">
							<li class="style-item" v-for="item in 12" :key="item">文艺</li>
						</ul>
					</div>
					<div class="style-btn d-flex">
						<div class="style-btn-item d-flex align-items-center">
							更多
							<img class="img-default btn-img" src="../../assets/images/bottom_14.png" alt />
						</div>
						<div class="style-btn-item d-flex align-items-center">
							多选
							<img class="img-default btn-img" src="../../assets/images/jia.png" alt />
						</div>
					</div>
				</div> -->
				<!-- 其他 -->
				<!-- <div class="rests d-flex align-items-center">
					<div class="rests-name">其他选项</div>
					<div class="rests-c d-flex align-items-center">
						<div class="rests-item d-flex align-items-center" @mouseover="selectStyle(item)" @mouseout="outStyle()" :class="{rest_item_active:item==iShow}"
						 v-for="item in 8" :key="item">
							文艺
							<div class="rests-img">
								<img class="img-default" src="../../assets/images/top_xia.svg" alt />
							</div>
						</div>
						<div class="rest-hiddex" @mouseover="selectStyle()" @mouseout="outStyle()" :class="{rest_active:isHidden}"></div>
					</div>
				</div> -->
				<!-- 商品列表 -->
				<div class="goods-box d-flex justify-content-between">
					<div class="goods-l">
						<div class="handpick-name">精选商品</div>
						<template v-if="ttshop_select.length">
							<div class="item" v-for="(item,index) in ttshop_select" :key="index">
								<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank">
									<img class="img-default img" :src="item.pic_url" alt :onerror="errorImg" />
									<div class="name">{{item.name}}</div>
									<!-- 价格面议 -->
									<template v-if="item.preActivityGoods">
										<div class="pic">￥{{item.preActivityGoods.pre_price}}</div>
									</template>
									<template v-else>
										<div class="pic" v-if="item.is_negotiable == 0">¥{{item.price}}</div>
										<div class="pic" v-else>{{item.price}}</div>
									</template>
									
									<!-- <div class="rests">已有 5400+评价</div> -->
								</router-link>
							</div>
						</template>
						<template v-else>
							<div class="zntj" v-if="datatype">
								<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
								<p>暂无精选商品</p>
							</div>
						</template>

					</div>
					<div class="goods-rs">
						<!-- 筛选 -->
						<div class="filtrate d-flex justify-content-between">
							<div class="filtrate-l d-flex">
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(0)" :class="{filtrate_active:0 == filtrateIndex}">综合</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(1)" :class="{filtrate_active:1 == filtrateIndex}">新品</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(2)" :class="{filtrate_active:2 == filtrateIndex}">
									价格
									<div class="filtrate-l-img">
										<img class="img-default" src="../../assets/images/filtrate_pic.svg" alt v-if="filtrateIndex != 2" />
										<div v-else>
											<img class="img-default" src="../../assets/images/filtrate_picnext.png" alt v-if="sort_type == 0" />
											<img class="img-default" src="../../assets/images/filtrate_picperv.png" alt v-if="sort_type == 1" />
										</div>
									</div>
								</div>
								<div class="filtrate-l-item d-flex align-items-center justify-content-center" @click="selectFiltrate(3)" :class="{filtrate_active:3 == filtrateIndex}">销量</div>
								<div class="filtrate-pic">
									<div class="d-flex align-items-center filtrate-pics">
										<div class="filtrate-pic-input d-flex align-items-center">
											￥
											<input type="number" v-model="smallnum" ref="smallnum" />
										</div>
										<div class="line"></div>
										<div class="filtrate-pic-input d-flex align-items-center">
											￥
											<input type="number" v-model="bignum" ref="bignum" />
										</div>
									</div>
									<div class="clearfloat filtrate-picbut">
										<span @click="confirms()">确定</span>
										<span @click="closenum()">清空</span>
									</div>
								</div>
							</div>
							<div class="filtrate-r d-flex align-items-center">
								<template v-if="false">
									<div class="filtrate-r-item d-flex align-items-center">
										<div class="filtrate-r-img">
											<img class="img-default" src="../../assets/images/select_unchecked.png" alt />
										</div>自营商品
									</div>
									<div class="filtrate-r-item d-flex align-items-center">
										<div class="filtrate-r-img">
											<img class="img-default" src="../../assets/images/select_unchecked.png" alt />
										</div>有货商品
									</div>
								</template>
								<div class="filtrate-r-all">共 {{ttshop_znum}}个商品</div>
								<div class="filtrate-r-page d-flex align-items-center" v-if="ttshop_listshop.length">
									<div class="page-img" :style="{'cursor': currentPage1<=1 ? 'no-drop' : 'pointer'}" @click="page_prevs">
										<img class="img-default" src="../../assets/images/goods_left.png" alt />
									</div>
									<div class="page-num">
										<span>{{currentPage1 * limit > ttshop_znum ? ttshop_znum : currentPage1 * limit}}</span> /{{ttshop_znum}}
									</div>
									<div class="page-img" :style="{'cursor': currentPage1>=page_count ? 'no-drop' : 'pointer'}" @click="page_nexts">
										<img class="img-default" src="../../assets/images/goods_right.png" alt />
									</div>
								</div>
							</div>
						</div>
						<!-- 商品 -->
						<div v-if="ttshop_listshop.length">
							<ul class="list d-flex flex-wrap">
								<li class="item" v-for="(item,index) in ttshop_listshop" :key="index" @click="listrouter(item.id)">
									<img class="img-default item-img" :src="item.pic_url" alt :onerror="errorImg" />
									<div class="img-list d-flex" :class="['img-list','img-list'+index]" :style="{padding: item.pic_list.length<=6 ? '0 0': '0 18px'}">
										<div class="swiper-container img-listcon swiper-no-swiping">
											<div class="clearfloat swiper-wrapper">
												<div class="img-item swiper-slide" v-for="(items,indexs) in item.pic_list" :key="indexs" @mouseenter="enter(items,index)">
													<img class="img-default img" :src="items" alt :onerror="errorImg" />
												</div>
											</div>
										</div>
										<!-- 左右箭头 -->
										<div class="swiper-button-prev ttshop_prev" @click.stop="ttshop_prev()" v-if="item.pic_list.length>6"></div>
										<div class="swiper-button-next ttshop_next" @click.stop="ttshop_next()" v-if="item.pic_list.length>6"></div>
									</div>
									<template v-if="item.preActivityGoods">
										<div class="pic">￥{{item.preActivityGoods.pre_price}}</div>
									</template>
									<template v-else>
										<div class="pic" v-if="item.is_negotiable == 0">¥{{item.price}}</div>
										<div class="pic" v-else>{{item.price}}</div>
									</template>
									
									<div class="name" v-if="item.high_name" v-html="item.high_name"></div>
									<div class="name" v-else>{{item.name}}</div>
									<div class="evaluate" v-if="false">
										<span>540+</span>评价
									</div>
									<div class="shop d-flex align-items-center">
										<img class="img-default shop-img" :src="item.logo" alt :onerror="errorImg" />
										<span class="flex_1 show-one-lines" v-text="item.mch_id == 0 ? '平台自营' : item.mch_name"></span>
									</div>
									<div class="label">
										<span class="presell" v-if="item.preActivityGoods">预售</span>
										<span v-for="(itemed,index) in item.service" :key="index">{{itemed}}</span>
									</div>
									<div class="operation d-flex align-items-center justify-content-between" v-if="false">
										<div class="operation-item d-flex align-items-center">
											<img class="img-default operation-img" src="../../assets/images/select_unchecked.png" alt />
											对比
										</div>
										<div class="line"></div>
										<div class="operation-item d-flex align-items-center">
											<img class="img-default operation-img" src="../../assets/images/collect.png" alt />
											收藏
										</div>
										<div class="line"></div>
										<div class="operation-item d-flex align-items-center" v-if="item.preActivityGoods">
											<img class="img-default operation-img" src="../../assets/images/cat_w.png" alt />
											加入购物车
										</div>
									</div>
								</li>
							</ul>
							<div class="goods-paging d-flex align-items-center justify-content-center">
								<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="limit"
								 :hide-on-single-page='value' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
							</div>
						</div>
						<!-- 暂无商品时暂时 -->
						<template v-else>
							<div class="zanwugoods" v-if="datatype">
								<img class="img-default" src="../../assets/images/ttshop_zanwu.png" alt="">
								<p>暂无商品</p>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				brandIndex: false,
				more: true,
				iShow: -1,
				value: true,
				isHidden: false,
				filtrateIndex: 0,
				sort_type: '', //价格上下
				currentPage1: 1, //页数
				datatype: false,
				id: this.$route.query.id, //商品id
				brand_id: this.$route.query.brand_id, //品牌id
				ttshop_hotshop: '', //热卖商品
				ttshop_catlist: '', //面包屑分类
				ttshop_brand: '', //品牌
				ttshop_select: '', //精选商品
				ttshop_listshop: '', //商品列表
				ttshop_znum: 0, //总商品数
				limit: 20, //每页条数
				smallnum: '', //最小值
				bignum: '', ///最大值
				start_price: '', //传最小值
				end_price: '', //传最大值
				page_count: '', //总页数
				keyword: this.$route.query.keyword, // 搜索文字
				errorImg: 'this.src="' + require('../../assets/images/lodingsb.svg') + '"', //图片加载失败
				is_coupon:0,
				goods_id:'',
				mch_id:'',
				mch_cat_id:'',
			};
		},
		mounted() {
			this.shoplistapi();
		},
		watch: {
			'$route'(to, from) { //监听路由是否变化
				if (to.query.id != from.query.id || to.query.keyword != from.query.keyword || to.query.brand_id != from.query.brand_id) {
					this.id = to.query.id;
					this.keyword = to.query.keyword;
					this.brand_id = to.query.brand_id;
					this.shoplistapi(); //重新加载数据
				}
			}
		},
		created(){
			if(this.$route.query.is_coupon){
				this.is_coupon=this.$route.query.is_coupon
			}
			if(this.$route.query.cat_id){
				this.id=this.$route.query.cat_id
			}
			if(this.$route.query.goods_id){
				this.goods_id=this.$route.query.goods_id
			}
			if(this.$route.query.mch_id){
				this.mch_id=this.$route.query.mch_id
			}
			if(this.$route.query.mch_cat_id){
				this.mch_cat_id=this.$route.query.mch_cat_id;
			}
		},
		methods: {
			shoplistapi() {
				let that=this;
				this.$loading();
				this.datatype = false;
				let data = {
					cat_id: this.id,
					page: this.currentPage1,
					limit: this.limit,
					brand_id: this.brand_id,
					sort: this.filtrateIndex,
					sort_type: this.sort_type,
					end_price: this.end_price,
					start_price: this.start_price,
					keyword: this.keyword,
					is_coupon:this.is_coupon,
					goods_id:this.goods_id,
					mch_id:this.mch_id,
					mch_cat_id:this.mch_cat_id,
				};
				this.$api.shopList(data).then(res => {
					that.$loading().close();
					that.ttshop_hotshop = res.data.hot_list||res.data.hot_List;
					that.ttshop_catlist = res.data.cat_list;
					if (!that.ttshop_brand.length) {
						that.ttshop_brand = res.data.brand_list;
					}
					that.ttshop_select = res.data.select_list||[];
					that.ttshop_listshop = res.data.list;
					that.ttshop_znum = Number(res.data.row_count);
					that.page_count = res.data.page_count
					that.datatype = true;
					// 商品轮播
					setTimeout(function() {
						for (let i = 0; i < res.data.list.length; i++) {
							let element = ".img-list" + i + " .img-listcon";
							let nextEl = ".img-list" + i + " .ttshop_next";
							let prevEl = ".img-list" + i + " .ttshop_prev";
							let mySwiper = new Swiper(element, {
								loop: false,
								slidesPerView: 5,
								spaceBetween: 5,
								observer: true,
								observeParents: true,
								navigation: {
									nextEl: nextEl,
									prevEl: prevEl,
								}
							});
						}
					}, 500)
				}).catch(err => {
					that.common.message(that, err);
				});
			},
			// 点击跳转详情
			listrouter(id) {
				let url = this.$router.resolve({
					path: "/pages/goods/goods",
					query: {
						id: id
					}
				})
				window.open(url.href);
			},
			ttshop_prev() {},
			ttshop_next() {},
			// 二级分类
			sort(id) {
				if (this.id == id) {
					return false;
				}
				this.id = id;
				this.brand_id = '';
				this.keyword = '';
				this.$router.push({
					path: '/list',
					query: {
						id: id
					}
				})
			},
			// 删除品牌
			closeid() {
				this.brand_id = '';
				this.$router.push({
					path: '/list',
					query: {
						id: this.id
					}
				})
			},
			// 更多点击事件
			unfoldBrand(index) {
				this.brandIndex = !this.brandIndex;
			},
			// 品牌点击事件
			selectBrand(id) {
				if (this.id == id) {
					return false;
				}
				this.brand_id = id;
				this.$router.push({
					path: '/list',
					query: {
						id: this.id,
						brand_id: id
					}
				})
			},
			// 导航分页上一页
			page_prevs() {
				if (this.currentPage1 > 1) {
					this.currentPage1--;
					this.common.backTop();
					this.shoplistapi();
				}
			},
			// 导航分页下一页
			page_nexts() {
				if (this.currentPage1 < this.page_count) {
					this.currentPage1++;
					this.common.backTop();
					this.shoplistapi();
				}
			},
			// 输入分页
			handleCurrentChange(e) {
				this.currentPage1 = e;
				this.common.backTop();
				this.shoplistapi();
			},
			// 商品小图片移入事件
			enter(src, index) {
				if (src) {
					this.ttshop_listshop[index].pic_url = src;
				}
			},
			// 价格最大值最小值筛选
			confirms() {
				let samlls = Number(this.$refs.smallnum.value);
				let bigs = Number(this.$refs.bignum.value);
				if (samlls > bigs) {
					this.end_price = samlls;
					this.start_price = bigs;
					this.smallnum = bigs;
					this.bignum = samlls;
					// this.$router.push({path:'/list',query:{id: this.id,brand_id:this.brand_id,start_price:this.start_price,end_price:this.end_price}})
				} else {
					this.end_price = bigs;
					this.start_price = samlls;
					this.smallnum = samlls;
					this.bignum = bigs;
				}
				this.currentPage1 = 1;
				this.shoplistapi();
			},
			closenum() {
				this.smallnum = "";
				this.bignum = "";
				this.end_price = "";
				this.start_price = "";
				this.currentPage1 = 1;
				this.shoplistapi();
			},
			// 多选点击事件
			moreSelect() {
				this.more = false;
				this.brandIndex = true;
			},
			// 确定
			brandConfirm() {},
			// 取消
			brandCancel() {
				this.more = true;
				this.brandIndex = false;
			},
			// 鼠标移入事件
			selectStyle(item) {
				this.iShow = item;
				this.isHidden = true;
			},
			// 鼠标移出事件
			outStyle() {
				this.iShow = -1;
				this.isHidden = false;
			},
			selectFiltrate(index) {
				if (this.filtrateIndex == index) {
					if (index == 2) {
						this.sort_type == 0 ? this.sort_type = 1 : this.sort_type = 0
					} else {
						return false;
					}
				}
				this.filtrateIndex = index;
				this.currentPage1 = 1;
				this.shoplistapi();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.content {
		padding-bottom: 60px;
		box-sizing: border-box;
	}

	.goods-paging {
		margin: 40px 0;
	}

	.brand_active {
		height: 208px !important;
		overflow-y: scroll !important;
	}

	.rest_active {
		visibility: visible !important;
	}

	.rest_item_active {
		border-color: #ff0e25 !important;
		border-bottom-color: #fff !important;
		z-index: 3 !important;
	}

	.filtrate_active {
		border-bottom-color: #ff0e25 !important;
		color: #ff0e25 !important;
	}

	// 热卖推荐
	.hot {
		height: 160px;
		background-color: #f2f2f2;
		margin-top: 16px;
		display: flex;

		.hot-img {
			width: 40px;
			height: 93px;
			margin-left: 8px;
		}

		.hot-list {
			height: 160px;
			display: flex;
			align-items: center;

			.item {
				margin-left: 20px;
				display: flex;
				padding: 10px;
				background-color: #fff;

				a {
					display: flex;
				}

				.item-img {
					width: 100px;
					height: 100px;
				}

				.item-r {
					margin-left: 10px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.item-name {
						width: 130px;
						display: -webkit-box;
						overflow: hidden;
						text-overflow: ellipsis;
						word-wrap: break-word;
						white-space: normal !important;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						transition: .5s;
						-moz-transition: .5s;
						-webkit-transition: .5s;
						-o-transition: .5s;
					}

					.item-pic {
						font-size: 14px;
						color: #ff0e25;
						font-weight: 600;
					}

					.item-btn {
						width: 72px;
						height: 24px;
						background: #fff0f1;
						border: 1px solid #ff3346;
						color: #ff0e25;
						display: flex;
						justify-content: center;
						align-items: center;
						border-radius: 2px;
					}
				}

				&:hover .item-name {
					color: #ff0e25;
				}
			}
		}
	}

	//面包屑
	.nav {
		height: 56px;
		border-bottom: 1px solid #ebebeb;

		.nav-item {
			color: #999999;

			a {
				color: #999;
				transition: .5s;
				-moz-transition: .5s;
				-webkit-transition: .5s;
				-o-transition: .5s;

				&:hover {
					color: #ff0e25;
				}
			}
		}

		.nav-img {
			height: 12px;
			width: 12px;
		}

		.nav-items {
			height: 24px;
			position: relative;
			overflow: hidden;
			background-color: #fff;
			transition: 0.3s;

			&:hover {
				overflow: visible;

				dt {
					border-color: #ff0e25;
					border-bottom-color: #fff;
					z-index: 41;
					border-radius: 3px 3px 0 0;

					div {
						color: #ff0e25;
					}
				}

				dd {
					z-index: 40;
					border: 1px solid #ff0e25;
				}
			}

			&:hover ~ .nav-items dt{
				// border-bottom-color:#ff0e25 ;
				z-index: 1;
			}
			dt {
				padding: 0px 4px 0px 8px;
				// line-height: 22px;
				height: 24px;
				border: 1px solid #ebebeb;
				position: relative;
				box-sizing: border-box;
				border-radius: 3px;
				background-color: #fff;
				z-index: 200;
			}

			.nav-xia {
				height: 12px;
				width: 12px;
				margin-left: 8px;
			}

			dd {
				width: 304px;
				padding: 6px 8px 10px 10px;
				position: absolute;
				top: 23px;	//原来的
				left: 0;
				background-color: #fff;
				line-height: 24px;

				div {
					// width: 96px;
					margin-right: 14px;
					cursor: pointer;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;

					&:hover {
						color: #ff0e25;
					}
				}

				div:last-child {
					margin-right: 0;
				}
			}
		}

		.nav-option {
			padding: 0px 4px 0px 8px;
			height: 24px;
			border: 1px solid #ebebeb;
			box-sizing: border-box;
			border-radius: 3px;
			border: 1px solid #ebebeb;
			background-color: #fafafa;
			margin-right: 8px;

			span {
				color: #ff0e25;
			}

			.nav-del {
				height: 12px;
				width: 12px;
				margin-left: 8px;
				cursor: pointer;
			}
		}
	}

	// 品牌
	.brand {
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #ebebeb;

		.brand-name {
			width: 100px;
		}

		.brand-c {
			width: 960px;

			.brand-index {
				margin-bottom: 20px;

				li {
					margin-right: 14px;
				}

				.brand-active {
					color: #ff0e25;
				}
			}

			.brand-box {
				height: 105px;
				overflow: hidden;
				padding: 3px;
			}

			.brand-item {
				width: 108px;
				height: 48px;
				padding: 4px;
				box-sizing: border-box;
				margin: 0 8px 8px 0;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				div {
					width: 100%;
					height: 100%;

					img {
						width: 100%;
						height: 100%;
						display: block;
						object-fit: contain;
					}
				}

				&:hover {
					box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

					.brand-po {
						top: 0;
					}
				}

				.brand-po {
					width: 108px;
					height: 48px;
					position: absolute;
					left: 0;
					top: -55px;
					background-color: #fff;
					opacity: 0.9;
					color: #ff0e25;
					transition: 0.5s;
					-moz-transition: 0.5s;
					-webkit-transition: 0.5s;
					-o-transition: 0.5s;
				}
			}

			.brand-btn {
				margin-top: 28px;

				.confirm {
					width: 56px;
					height: 24px;
					background: #ff0e25;
					border-radius: 2px;
					color: #fff;
				}

				.cancel {
					width: 56px;
					height: 24px;
					border-radius: 2px;
					border: 1px solid #ebebeb;
					color: #666666;
					margin-left: 8px;
				}
			}
		}

		.brand-btn {
			margin-left: auto;

			// width: ;
			.brand-btn-item {
				width: 54px;
				height: 24px;
				background: #f0f0f0;
				border-radius: 2px;
				padding-left: 8px;
				box-sizing: border-box;
				margin-left: 8px;
				cursor: pointer;

				.btn-img {
					height: 14px;
					width: 14px;
					display: block;
					margin-left: 4px;
				}
			}
		}
	}

	// 尺码
	.size {
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #ebebeb;

		.size-name {
			width: 100px;
		}

		.size-c {
			width: 930px;

			.size-item {
				margin-right: 42px;
			}
		}

		.size-btn {
			margin-left: auto;

			// width: ;
			.size-btn-item {
				width: 54px;
				height: 24px;
				background: #f0f0f0;
				border-radius: 2px;
				padding-left: 8px;
				box-sizing: border-box;
				margin-left: 8px;

				.btn-img {
					height: 14px;
					width: 14px;
					display: block;
					margin-left: 4px;
				}
			}
		}
	}

	// 颜色
	.color {
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #ebebeb;

		.color-name {
			width: 100px;
		}

		.color-c {
			width: 930px;

			.color-item {
				width: 24px;
				height: 24px;
				border-radius: 24px;
				background: rgba(187, 187, 187, 1);
				margin-right: 8px;
			}
		}

		.color-btn {
			margin-left: auto;

			// width: ;
			.color-btn-item {
				width: 54px;
				height: 24px;
				background: #f0f0f0;
				border-radius: 2px;
				padding-left: 8px;
				box-sizing: border-box;
				margin-left: 8px;

				.btn-img {
					height: 14px;
					width: 14px;
					display: block;
					margin-left: 4px;
				}
			}
		}
	}

	// 风格
	.style {
		padding: 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #ebebeb;

		.style-name {
			width: 100px;
		}

		.style-c {
			width: 930px;

			.style-item {
				margin-right: 44px;
			}
		}

		.style-btn {
			margin-left: auto;

			// width: ;
			.style-btn-item {
				width: 54px;
				height: 24px;
				background: #f0f0f0;
				border-radius: 2px;
				padding-left: 8px;
				box-sizing: border-box;
				margin-left: 8px;

				.btn-img {
					height: 14px;
					width: 14px;
					display: block;
					margin-left: 4px;
				}
			}
		}
	}

	// 其他
	.rests {
		height: 46px;
		box-sizing: border-box;
		border-bottom: 1px solid #ebebeb;

		.rests-name {
			width: 80px;
		}

		.rests-c {
			width: 930px;
			position: relative;

			.rests-item {
				height: 45px;
				padding: 0 20px;
				border: 1px solid transparent;
				transition: 0.3s;
				-moz-transition: 0.3s;
				-webkit-transition: 0.3s;
				-o-transition: 0.3s;
				border-radius: 3px 3px 0px 0px;
				background-color: #fff;
				box-sizing: border-box;

				.rests-img {
					height: 12px;
					width: 12px;
					margin-left: 8px;
					display: block;
				}
			}

			.rest-hiddex {
				width: 1108px;
				height: 100px;
				position: absolute;
				top: 44px;
				left: 0;
				border-radius: 0px 0px 3px 3px;
				border: 1px solid #ff0e25;
				background-color: #fff;
				visibility: hidden;
			}
		}
	}

	// 商品列表
	.goods-box {
		margin-top: 18px;

		// 暂无商品
		.zanwugoods {
			width: 100%;
			padding: 150px 0;
			box-sizing: border-box;

			img {
				display: block;
				width: 93px;
				height: 80px;
				margin: 0 auto 20px;
			}

			p {
				font-size: 16px;
				color: #333;
				text-align: center;
			}
		}

		// 精选商品
		.goods-l {
			width: 190px;
			height: 100%;
			padding: 12px;
			border: 1px solid #ebebeb;
			box-sizing: border-box;

			.handpick-name {
				font-size: 16px;
			}

			.zntj {
				width: 100%;
				padding: 40px 10px;
				box-sizing: border-box;

				img {
					display: block;
					width: 93px;
					height: 80px;
					margin: 0 auto 20px;
				}

				p {
					font-size: 14px;
					color: #333;
					text-align: center;
				}
			}

			.item {
				margin-top: 20px;
				cursor: pointer;

				.img {
					height: 160px;
					width: 160px;
				}

				.name {
					color: #666666;
					margin-top: 12px;
					position: relative;
					line-height: 20px;
					max-height: 36px;
					overflow: hidden;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;
					display: -webkit-box;
					text-overflow: ellipsis;
					word-wrap: break-word;
					white-space: normal !important;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;

					&::after {
						// content: "...";
						// position: absolute;
						// bottom: -4px;
						// right: 6px;
						// font-size: 16px;
						// padding-left: 2px;
						// background-color: #fff;
						// background: -webkit-linear-gradient(left, transparent, #fff 55%);
						// background: -o-linear-gradient(right, transparent, #fff 55%);
						// background: -moz-linear-gradient(right, transparent, #fff 55%);
						// background: linear-gradient(to right, transparent, #fff 55%);
					}
				}

				.pic {
					color: #ff4300;
					font-size: 20px;
					margin-top: 8px;
				}

				.rests {
					color: #666666;
					margin-top: 12px;
				}

				&:hover .name {
					color: #ff0e25;
				}
			}
		}

		.goods-rs {
			width: 987px;

			.filtrate {
				width: 987px;
				height: 40px;
				background: #fafafa;

				.filtrate-l-item {
					min-width: 64px;
					padding: 0 8px;
					box-sizing: border-box;
					// height: 40px;
					border-bottom: 2px solid transparent;
					color: #666666;
					cursor: pointer;

					.filtrate-l-img {
						height: 12px;
						width: 12px;
					}
				}

				.filtrate-pic {
					padding: 0 8px;
					position: relative;

					.filtrate-pics {
						height: 40px;
					}

					.filtrate-picbut {
						display: none;
						position: absolute;
						background: #fff;
						width: 100%;
						top: 39px;
						left: 0;
						padding: 8px;
						box-sizing: border-box;
						box-shadow: 0 15px 12px rgba(0, 0, 0, .1);

						span {
							float: left;
							font-size: 12px;
							color: #666;
							border: 1px solid #EBEBEB;
							border-radius: 2px;
							width: 56px;
							height: 24px;
							box-sizing: border-box;
							text-align: center;
							line-height: 20px;
							cursor: pointer;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;

							&:first-child {
								border-color: #FF3346;
								background: #FFF0F1;
								color: #FF0E25;
								margin-right: 8px;
							}

							&:last-child:hover {
								border-color: #FF3346;
								background: #FFF0F1;
								color: #FF0E25;
							}
						}
					}

					.filtrate-pic-input {
						width: 64px;
						height: 24px;
						background: #ffffff;
						border-radius: 2px;
						border: 1px solid #ebebeb;
						color: #999999;

						input {
							height: 24px;
							width: 50px;
						}
					}

					.line {
						width: 10px;
						height: 2px;
						background: #cccccc;
						margin: 0 4px;
					}

					&:hover {
						background: #fff;
						box-shadow: 0 0 12px 0 rgba(0, 0, 0, .1);
						border-radius: 2px;
					}

					&:hover .filtrate-picbut {
						display: block;
						border-radius: 0 0 2px 2px;
					}
				}

				.filtrate-r-item {
					height: 40px;
					padding: 0 10px;
					box-sizing: border-box;
					color: #666666;
					cursor: pointer;

					.filtrate-r-img {
						height: 12px;
						width: 12px;
						margin-right: 4px;
					}
				}

				.filtrate-r-all {
					margin-left: 40px;
					color: #666666;
					margin-right: 8px;
				}

				.filtrate-r-page {
					margin-right: 16px;

					.page-num {
						font-weight: bold;
						color: #666666;
						margin: 0 4px;

						span {
							font-weight: bold;
							color: #ff0e25;
						}
					}

					.page-img {
						height: 14px;
						width: 14px;
						cursor: pointer;
					}
				}
			}

			.list {
				width: 100%;
				cursor: pointer;

				// background-color: red;
				.item {
					width: 242px;
					// height: 458px;
					background-color: #fff;
					margin-right: 5px;
					margin-top: 20px;
					padding: 16px 12px;
					box-sizing: border-box;
					transition: .5s;
					-moz-transition: .5s;
					-webkit-transition: .5s;
					-o-transition: .5s;

					&:nth-child(4n) {
						margin-right: 0 !important;
					}

					&:hover {
						box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
					}

					.item-img {
						height: 218px;
						width: 218px;
					}

					.img-list {
						width: 100%;
						padding: 0 19px;
						box-sizing: border-box;
						margin-top: 8px;
						position: relative;

						.img-listcon {
							width: 100%;
							padding: 0 1px;
							box-sizing: border-box;

							.img-item {
								width: 32px !important;
								height: 32px;
								padding: 2px;
								border: 1px solid #ebebeb;
								box-sizing: border-box;
								margin-right: 5px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
								cursor: pointer;

								.img {
									width: 100%;
									height: 100%;
								}

								&:hover {
									border-color: #FF0E25;
								}

								&:last-child {
									margin-right: 0 !important;
								}
							}
						}

						.ttshop_prev {
							width: 14px;
							height: 14px;
							margin-top: -7px;
							background: url(../../assets/images/ttshop_scleft.png) center no-repeat;
							left: 0;
							cursor: pointer;
							z-index: 100;
							outline: none;
						}

						.ttshop_next {
							width: 14px;
							height: 14px;
							margin-top: -7px;
							background: url(../../assets/images/ttshop_scright.png) center no-repeat;
							right: 0;
							cursor: pointer;
							z-index: 100;
							outline: none;
						}
					}

					.pic {
						font-size: 20px;
						color: #ff4300;
						margin-top: 12px;
					}

					.name {
						width: 218px;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						margin-top: 8px;
						color: #666666;
					}

					.evaluate {
						margin-top: 8px;
						color: #999999;

						span {
							color: #0e9cff;
							margin-right: 4px;
						}
					}

					.shop {
						margin-top: 8px;


						.shop-img {
							width: 20px;
							height: 20px;
							border-radius: 20px;
							margin-right: 4px;
						}

						span {
							color: #666666;
						}
					}

					.label {
						margin-top: 8px;

						span {
							min-width: 32px;
							padding: 0px 4px;
							border-radius: 3px;
							border: 1px solid #ff0e25;
							box-sizing: border-box;
							display: inline-block;
							color: #ff0e25;
							margin: 0 4px 4px 0;
						}
						.presell {
							// width: 56px;
							// height: 28px;
							background: linear-gradient(270deg, #FF3860 0%, #FF2448 100%);
							border-radius: 4px;
							// display: flex;
							// align-items: center;
							// justify-content: center;
							// font-size: 20px;
							font-family: PingFangSC-Regular, PingFang SC;
							font-weight: 400;
							color: #FFFFFF;
							// line-height: 20px;
							// margin-right: 8px;
							// margin: 8px 8px 0 0;
							// padding: 0 8px;
						}
					}

					.operation {
						margin-top: 8px;
						height: 28px;
						border-top: 1px solid #ebebeb;
						border-bottom: 1px solid #ebebeb;
						padding: 0 8px;
						box-sizing: border-box;

						.line {
							width: 1px;
							height: 16px;
							background: #ebebeb;
						}

						.operation-item {
							color: #888888;

							.operation-img {
								width: 12px;
								height: 12px;
								margin-right: 4px;
								display: block;
							}
						}
					}
				}
			}
		}
	}
	
	
</style>
